import React from 'react';
import {Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ArrowButton from '../common/button-arrow';
import {USER_TYPE_REP, USER_TYPE_RETAILER} from '../../data/userTypes';


const buttonProps = {
  submit: false,
  arrow: false,
  ghost: false,
};

const updatePasswordUrls = {
  [USER_TYPE_RETAILER]: '/update-password',
  [USER_TYPE_REP]: '/team/update-password',
};

const updateSecurityQuestionUrls = {
  [USER_TYPE_RETAILER]: '/update-security-questions',
  [USER_TYPE_REP]: '/team/update-security-questions',
};

const UpdateSecurity = ({type}) => (
  <div>
    <Row>
      <Link to={updatePasswordUrls[type || USER_TYPE_REP]}>
        <ArrowButton {...buttonProps}>Update password</ArrowButton>
      </Link>
    </Row>
    <Row className="my-profile-details-buttons-security">
      <Link to={updateSecurityQuestionUrls[type || USER_TYPE_REP]}>
        <ArrowButton {...buttonProps}>Update security questions</ArrowButton>
      </Link>
    </Row>
  </div>
);

export default UpdateSecurity;



// WEBPACK FOOTER //
// ./src/components/my-profile/update-security.jsx